import { createEffect, createSignal, onCleanup } from 'solid-js'

export function useInfiniteScroll(onLoadMore: () => void) {
  const [target, setTarget] = createSignal<HTMLElement | null>(null)

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        onLoadMore()
      }
    },
    { threshold: 1.0 }
  )

  createEffect(() => {
    const currentTarget = target()
    if (currentTarget) {
      observer.observe(currentTarget)
    }
  })

  onCleanup(() => {
    if (target()) {
      observer.unobserve(target()!)
    }
  })

  return { setTarget }
}